document.addEventListener('DOMContentLoaded', function () {

    // ==============================
    // ✅ 从 YouTube URL 提取视频 ID
    // ==============================
    function getYoutubeVideoId(url) {
        if (!url) return null;
        try {
            const u = new URL(url);
            // youtu.be/xxxx 短链接
            if (u.hostname.includes('youtu.be')) {
                return u.pathname.slice(1).split('/')[0] || null;
            }
            // youtube.com/watch?v=xxxx
            if (u.hostname.includes('youtube.com')) {
                const v = u.searchParams.get('v');
                if (v) return v;
                // youtube.com/embed/xxxx
                const pathParts = u.pathname.split('/');
                if (pathParts[1] === 'embed') return pathParts[2] || null;
            }
        } catch (e) {
            console.warn('Invalid YouTube URL:', url);
        }
        return null;
    }

    const triggers = document.querySelectorAll('.youtube-modal-trigger');
    const modal = document.getElementById('youtube-modal');
    const iframe = document.getElementById('youtube-iframe');
    const closeBtn = document.getElementById('close-modal-supportcenter');

    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const videoUrl = this.dataset.videoUrl;
            const videoId = getYoutubeVideoId(videoUrl);
            if (videoId) {
                iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`;
                modal.style.display = 'flex';
                document.body.style.overflow = 'hidden'; // 防止背景滚动
            }
        });
    });

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal(); // 点击黑边关闭
    });

    function closeModal() {
        modal.style.display = 'none';
        iframe.src = ''; // 停止视频
        document.body.style.overflow = ''; // 恢复滚动
    }

    // ESC 关闭
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.style.display === 'flex') {
            closeModal();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // 仅针对移动端容器
    const mobileContainer = document.getElementById('supportCenter_manual_video_mobile');

    if (!mobileContainer) return;

    const titles = mobileContainer.querySelectorAll('.item_title');

    titles.forEach(title => {
        title.addEventListener('click', function () {
            const item = this.closest('.item');
            if (!item) return;

            // 切换 collapsed 类
            item.classList.toggle('collapsed');

            // 可选：改变标题背景色反馈
            // （根据你的设计决定是否需要）
        });
    });
});